import React from 'react';
import {StorageKey} from "../../../enums/StorageKey";
import {t, Trans} from "@lingui/macro";
import dayjs from 'dayjs';
import Big from "big.js";
import FormatNumber from "../../FormatNumber";
import {Button} from "antd";
import {DateTimeWidth} from "../../Table/Common/CommonWidths";
import {CreatedAtTd} from "../../Table/Common/CreatedAtTd";
import TransactionType from "../../TransactionType";
import { sortColumnByString } from '../sortColumnByString';
import { amountSorter, numberSorter } from './BankReconciliationManual';

function getColumns(props) {
    const { onSelect = () => {} } = props;
    return [
        {
            title: t`No.`,
            dataIndex: 'number',
            key: 'number',
            width: 125,
            sorter: numberSorter,
            render: text => text || '-',
        },
        {
            title: t`Type`,
            dataIndex: 'type',
            key: 'type',
            width: 140,
            render: (text, record) => <TransactionType record={record} />,
        },
        {
            title: t`Date`,
            dataIndex: 'date',
            key: 'date',
            width: 100,
            sorter: (a, b) => a.date.localeCompare(b.date),
            render: text => dayjs(text).format('DD/MM/YYYY'),
        },
        {
            title: t`Contact`,
            dataIndex: 'contact_name',
            key: 'name',
            sorter: (a, b) => sortColumnByString(a.contact_name, b.contact_name),
            // sorter: (a, b) => {
            //     if (a.contact_name != null && b.contact_name != null)
            //         return a.contact_name.localeCompare(b.contact_name);
            //     if (a.contact_name) // b is missing
            //         return 1;
            //     if (b.contact_name) // a is missing
            //         return -1;
            //     return 0;
            // },
            render: text => (
                <span>{text || '-'}</span>
            ),
        },
        {
            title: t`Reference No.`,
            dataIndex: 'number2',
            key: 'number2',
            ellipsis: true,
            sorter: numberSorter,
            render: text => <span>{text || '-'}</span>,
        },
        {
            title: t`Description`,
            dataIndex: 'description',
            key: 'description',
            width: 150,
            // ellipsis:true,
            render: text => text || '-',
        },
        {
            key: 'debit',
            title: <Trans>Spent</Trans>,
            dataIndex: 'amount',
            align: 'right',
            sorter: (a, b, sortOrder) => {
                const amountA = a.amount < 0 ? -a.amount : null;
                const amountB = b.amount < 0 ? -b.amount : null;
                return amountSorter(amountA, amountB, sortOrder);
            },
            render: text => {
                const amountB = new Big(text);
                if (amountB.gte(0))
                    return null;
                return <FormatNumber amount={-text} />;
            },
        },
        {
            key: 'credit',
            title: <Trans>Received</Trans>,
            dataIndex: 'amount',
            align: 'right',
            sorter: (a, b, sortOrder) => {
                const amountA = a.amount < 0 ? null : a.amount;
                const amountB = b.amount < 0 ? null : b.amount;
                return amountSorter(amountA, amountB, sortOrder);
            },
            render: text => {
                const amountB = new Big(text);
                if (amountB.lt(0))
                    return null;
                return <FormatNumber amount={text} />;
            },
        },
        {
            title: t`Created At`,
            dataIndex: 'created_at',
            key: 'created_at',
            width: DateTimeWidth,
            ellipsis: true,
            render: text => <CreatedAtTd text={text} />,
        },
        {
            key: 'actions',
            label: "Actions",
            width: 85,
            render: (text, ledger) => (
                <Button size="small" disabled={ledger.isSelected} onClick={() => onSelect(ledger)}>
                    { ledger.isSelected ? t`Selected` : t`Select`}
                </Button>
            ),
        },
    ];
}

export default {
    storageKey: StorageKey.bank_reconciliation_smart,
    required: [
        'number',
        'type',
        'date',
        'debit',
        'credit',
        'actions',
    ],
    defaulto: [
        'name',
        'number2',
        'description',
    ],
    getColumns,
};
